import SystemDataService from '../Services/SystemDataService';

// --- 1. CACHE STORAGE ---
let ALL_SERVICES_CACHE = null;
const SERVICE_SLUG_CACHE = {};

// --- ASSETS CONSTANTS (Updated for Always On Air) --
const ASSETS_URL = "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/";
const ICONS_BASE = 'https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/icons/';

const ICONS = {
    AIRFLOW: ICONS_BASE + 'always_on_air_AIRFLOW CORRECTIONS.jpeg',
    ELECTRICAL: ICONS_BASE + 'always_on_air_ELECTRICAL RESTORATION.jpeg',
    REFRIGERANT: ICONS_BASE + 'always_on_air_REFRIGERANT CIRCUIT.jpeg',
    CORROSION: ICONS_BASE + 'always_on_air_CORROSION PROTECTION.jpeg',
    SURGE: ICONS_BASE + 'always_on_air_SURGE PROTECTION.jpeg',
    IAQ: ICONS_BASE + 'always_on_air_INDOOR AIR QUALITY.jpeg',
    DEHUMIDIFIER: ICONS_BASE + 'always_on_air_SMART HUMIDISTAT CONTROLS.jpeg',
    MINI_SPLIT: ICONS_BASE + 'always_on_air_DUCTLESS MINI-SPLITS.jpeg',
    HEAT_PUMP: ICONS_BASE + 'always_on_air_ELECTRIC HEAT PUMPS.jpeg',
    GAS: ICONS_BASE + 'always_on_air_GAS HEATERS.jpeg',
    HYBRID: ICONS_BASE + 'always_on_air_HYBRID SYSTEMS.jpeg',
    CRAWLSPACE: ICONS_BASE + 'always_on_air_CRAWLSPACE SOLUTIONS.jpeg',
    HARDENING: ICONS_BASE + 'always_on_air_SYSTEM HARDENING.jpeg'
};

const serviceFormatter = [
    {
        id: "srv-hvac-install",
        isActive: true,
        slug: "hvac-installation",
        name: "HVAC Installation",
        image: ICONS.INSTALL,

        // --- META & CARD ---
        cardTitle: "High-Efficiency System Installations",
        cardDescription: "Precision-engineered AC replacements using Manual J calculations for maximum efficiency and legal compliance in Jacksonville.",
        cardImage: "https://pryvw6vsbf7zfgtoyrmgbwvtqm0kcphn.lambda-url.us-east-2.on.aws/AlwaysOnAir/images/1770644036309-image.png",
        cardButtonText: "Get Free Estimate",
        isCallNow: false,

        seoTitle: "Expert AC Repair & HVAC Services in Jacksonville & NE Florida | Always On Air AC",
        seoDescription: "Don’t settle for a 'guess-timated' system. We perform full Manual J load calculations to double the life of your equipment in Duval & St. Johns Counties.",

        // --- HERO ---
        hero: {
            title: "Expert AC Repair & HVAC Services in Jacksonville & NE Florida",
            subtitle: "Precision Engineering. Permitted Reliability. Perfect Comfort",
            description: "We don't just 'swap boxes.' We perform full Manual J load calculations to ensure your new unit is sized perfectly for your home’s square footage—maximizing efficiency and doubling the life of your equipment.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_2.mp4",
            imageMobile: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/1770644036309-image.png",
        },

        // --- METRICS (From Case Study & Form) ---
        stats: [
            { label: "Energy Bill Reduction", value: 35, suffix: "%" },
            { label: "Warranty Period", value: 10, suffix: " Years" },
            { label: "Tax Credit Available", value: 2000, prefix: "$" },
            { label: "Performance Delta T", value: 20, suffix: "°F" }
        ],

        // --- PROCESS (Installation Engineering) ---
        process: {
            title: "Precision Engineering. Permitted Reliability. Perfect Comfort",
            content: "We handle the red tape and the physics so you don't have to.",
            steps: [
                {
                    title: "1. Permitting & Planning",
                    description: "We handle the red tape and pull all necessary mechanical and electrical permits to ensure valid warranties and insurance compliance."
                },
                {
                    title: "2. Engineering Assessment",
                    description: "We check ductwork static pressure and verify electrical panel capacity to handle high-output 2026 Energy Star models."
                },
                {
                    title: "3. Manual J Load Calculation",
                    description: "We analyze insulation R-values, window orientation, and square footage to ensure your system is perfectly sized—not guessed."
                },
                {
                    title: "4. Professional Commissioning",
                    description: "We verify performance metrics, bring line sets to 2026 safety codes, and provide the certificate for your $2,000 Federal Tax Credit."
                }
            ]
        },

        // --- STORIES (Case Study) ---
        stories: {
            title: "The Result: 35% Reduction in Energy",
            content: "We identified a master bedroom 'hot spot' caused by a 1.5-ton oversized system. After performing a Manual J calculation and redesigning the return air plenum for 25% better CFM, we installed a SEER2-rated Heat Pump. The customer achieved a perfect Delta T of 20°F and immediate bill savings.",
            image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (System Types & IAQ) ---
        SystemTypes: [
            {
                title: "Hybrid (Dual-Fuel) Systems",
                text: "Combines an electric heat pump with a gas furnace. Saves on utility bills by using the most efficient fuel source based on 2026 standards.",
                image: ICONS.HYBRID,
            },
            {
                title: "Ductless Mini-Splits",
                text: "Higher energy efficiency with zero 'duct loss.' Ideal for garage conversions, home offices, or older homes without ductwork.",
                image: ICONS.MINI_SPLIT,
            },
            {
                title: "Indoor Air Quality (IAQ)",
                text: "UV Germicidal Lights and Whole-Home Air Purifiers (REME HALO) to kill mold/bacteria in the damp Jacksonville climate.",
                image: ICONS.IAQ,
            },
            {
                title: "Surge Protection",
                text: "Dedicated HVAC surge protectors to save expensive control boards from Duval’s frequent power spikes.",
                image: ICONS.HARDENING,
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        maintenanceTips: {
            title: "The Pro’s Advice",
            subtitle: "What you can do to help your system last longer.",
            tips: [
                "The Filter Rule: Check every 30 days. If you can't see light through it, your blower motor is 'choking'.",
                "Give it Space: Keep bushes trimmed at least 2 feet back. Your outdoor unit needs to 'breathe' to dump heat.",
                "Listen to the System: Catching a $200 part today (humming/clicking) prevents a $2,000 repair next month.",
                "Duct Sealing: Stop air you're paying to heat from escaping into the attic by sealing leak points."
            ],
            footerContent: {
                preLink: "Learn more about our ",
                linkUrl: "/maintenance",
                linkText: "VIP Preventative Tune-Ups",
            }
        },

        // --- NEIGHBORHOODS (SEO) ---
        neighborhoods: {
            headline: "Serving the First Coast",
            regions: [
                { name: "Duval County", areas: "Jacksonville, Atlantic Beach, Neptune Beach, Mandarin, Riverside, San Marco" },
                { name: "Clay County", areas: "Orange Park, Fleming Island, Middleburg, Green Cove Springs" },
                { name: "St. Johns County", areas: "St. Augustine, Ponte Vedra Beach, Nocatee, World Golf Village" }
            ]
        },

        // --- FAQ (Full Set) ---
        faqList: [
            {
                question: "How long does a typical installation take?",
                answer: "Most residential change-outs are completed in one day. We usually arrive at 8:00 AM and have you back in conditioned air by the afternoon."
            },
            {
                question: "Will you handle the permits and inspections?",
                answer: "Yes. Every installation is 100% legal. We handle the city paperwork, coordinate electrical subs, and schedule the final inspection."
            },
            {
                question: "How do I know what size (tonnage) system I need?",
                answer: "We don't guess. We perform a Manual J Load Calculation, looking at your insulation, windows, and square footage to find the exact BTU load required."
            },
            {
                question: "What is SEER2 and why does it matter?",
                answer: "SEER2 is the new 2026 industry standard for efficiency. Higher numbers mean lower electric bills. We offer systems ranging from 14.3 up to 20+ SEER2."
            },
            {
                question: "Can I switch from a Gas Furnace to an Electric Heat Pump?",
                answer: "Absolutely. We evaluate your current panel for the load and guide you through Dual-Fuel options that maximize both reliability and federal tax credits."
            },
            {
                question: "Do you offer financing for new systems?",
                answer: "Yes. We offer several options, including 0% interest for 12–18 months for qualified buyers, to help you get the system you need comfortably."
            },
            {
                question: "What kind of warranty comes with my new system?",
                answer: "All installations come with a 10-Year Parts Warranty (upon registration) and our own Labor Guarantee. If our workmanship is at fault, we fix it—period."
            }
        ],
        schema: {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "HVAC Installation",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-heating-furnace",
        "isActive": true,
        "slug": "heating-furnace-repair-installation",
        "name": "Heating & Furnace Services",
        "image": "ICONS.HEATING",

        // --- META & CARD ---
        "cardTitle": "Safe, Reliable Heating Solutions",
        "cardDescription": "From historic gas furnaces to modern high-efficiency heat pumps, we ensure your 'Heat' switch works perfectly when the First Coast freeze hits.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Schedule Heating Service",
        "isCallNow": false,

        "seoTitle": "Furnace Repair & Installation Jacksonville | Expert Heating Services by Always On Air AC",
        "seoDescription": "Expert gas & electric furnace repair in Jacksonville, St. Johns, & Clay County. Safety certifications, high-efficiency installs, and emergency 'no-heat' support.",

        // --- HERO ---
        "hero": {
            "title": "Safe, Reliable Heat for the First Coast",
            "subtitle": "When the North Florida Freeze Hits, Always On Air AC Keeps You Warm",
            "description": "In Jacksonville, furnaces sit idle for 10 months a year, making them prone to dust, rust, and electrical failure. We provide the precision repairs and high-efficiency installations needed to weather the winter safely.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_3.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Safety Checkpoints", "value": 21, "suffix": " Point Inspection" },
            { "label": "Emergency Response", "value": 24, "suffix": "/7 Support" },
            { "label": "Energy Star Models", "value": 2026, "prefix": "Class of " },
            { "label": "CO2 Safety Rating", "value": 100, "suffix": "% Certified" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "Safety-First Heating Protocol",
            "content": "Because local furnaces sit idle for most of the year, our protocol is designed to clear 'summer dust' and ensure mechanical safety.",
            "steps": [
                {
                    "title": "1. Precision Tune-Up",
                    "description": "We clear dust and debris buildup that causes burning smells and potential fire hazards after months of dormancy."
                },
                {
                    "title": "2. Safety Diagnostics",
                    "description": "Using advanced sensors, we check for gas leaks and cracked heat exchangers to prevent Carbon Monoxide exposure."
                },
                {
                    "title": "3. Reliability Check",
                    "description": "We test startup components like ignitors and capacitors to ensure your system fires up on the first cold night."
                },
                {
                    "title": "4. Efficiency Calibration",
                    "description": "We optimize heat pump defrost boards and electric strip sequencing to prevent spikes in your JEA or Clay Electric bills."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "The Result: 40% Lower Winter Bills",
            "content": "For a family in Eagle Harbor, we repaired a failed defrost board that was forcing their system into expensive 'Emergency Heat' mode. By restoring the heat pump’s efficiency, we slashed their electric bill and restored perfect comfort.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (System Types) ---
        "SystemTypes": [
            {
                "title": "Gas Furnaces",
                "text": "Specialized cleaning and safety inspections for historic Riverside & Avondale natural gas systems.",
                "image": ICONS.GAS
            },
            {
                "title": "Electric Air Handlers",
                "text": "Optimization of electric 'heat strips' to prevent the common Jacksonville 'utility bill spike'.",
                "image": ICONS.ELECTRICAL
            },
            {
                "title": "Heat Pump Systems",
                "text": "Advanced troubleshooting for reversing valves and defrost boards to maximize winter SEER2 efficiency.",
                "image": ICONS.HEAT_PUMP
            },
            {
                "title": "Safety Ecosystem",
                "text": "Interconnected Carbon Monoxide detectors and iWave-R air purification to keep winter air safe and clean.",
                "image": ICONS.IAQ
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "What you can do to help your heater last longer.",
            "tips": [
                "The October Test Run: Turn on your heat in late October for 15 mins to burn off dust before you actually need it.",
                "The Blue Flame Rule: Gas burners should be steady and blue. A yellow/orange flame is a sign of unsafe combustion.",
                "The Filter Flip: Heating requires higher airflow than cooling. Swap a fresh filter before the first freeze.",
                "Clear the Unit: Ensure fallen leaves or pine needles aren't burying your outdoor unit, which causes it to freeze over."
            ],
            "footerContent": {
                "preLink": "Sign up for our ",
                "linkUrl": "/maintenance",
                "linkText": "VIP Heating Safety Tune-Ups"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving the First Coast",
            "regions": [
                { "name": "Duval County", "areas": "Riverside (Historic Gas), Avondale, San Marco, Mandarin, Southside, Jax Beach" },
                { "name": "Clay County", "areas": "Fleming Island (Eagle Harbor), Orange Park, Middleburg, Green Cove Springs" },
                { "name": "St. Johns County", "areas": "Ponte Vedra (Coastal Defense), Nocatee, St. Augustine, Julington Creek" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "Why does my furnace smell like it’s burning?",
                "answer": "Dust settles on the heating elements during the 9 months it sits idle. This 'burns off' during the first run. If the smell lasts longer than 30 minutes, call us immediately."
            },
            {
                "question": "Should I set my thermostat to 'Auto' or 'On'?",
                "answer": "Always use 'Auto'. In 'On' mode, the fan pulls in unheated humid air, creating a chilly 'wind chill' effect when the furnace cycle ends."
            },
            {
                "question": "Why is my outdoor unit covered in ice?",
                "answer": "Occasional frost is normal for heat pumps in low temps, but if it's a solid block of ice, your defrost board is likely broken, costing you a fortune in backup electric heat."
            },
            {
                "question": "What is 'Emergency Heat' (Aux Heat)?",
                "answer": "It is a backup electric heater. It uses 3 to 4 times more electricity than your heat pump. If this light stays on constantly, your system needs a professional diagnostic."
            },
            {
                "question": "Do I really need a CO detector in Florida?",
                "answer": "Yes. If you have any gas appliance, a CO detector is a life-safety requirement. Because our furnaces sit idle, they are prone to rust-through cracks that leak CO."
            },
            {
                "question": "My house is cold, but the furnace is running. What's wrong?",
                "answer": "You likely have leaky attic ductwork or burnt-out electric heat strips. We can perform a thermal check to find the source of the heat loss."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Furnace Repair & Installation",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-pool-heating",
        "isActive": true,
        "slug": "pool-heater-repair-installation",
        "name": "Pool Heater Services",
        "image": "ICONS.POOL_HEATER",

        // --- META & CARD ---
        "cardTitle": "Stop Shivering. Start Swimming.",
        "cardDescription": "Professional repair and optimization for gas heaters and heat pumps. We bridge the gap between pool maintenance and HVAC engineering.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png",
        "cardButtonText": "Get My Pool Warm",
        "isCallNow": false,

        "seoTitle": "Pool Heater Repair & Installation Jacksonville | Always On Air AC",
        "seoDescription": "Expert pool heater repair in Duval, Clay, & St. Johns Counties. We specialize in high-efficiency heat pumps, gas heaters, and corrosion defense.",

        // --- HERO ---
        "hero": {
            "title": "Stop Shivering. Start Swimming.",
            "subtitle": "Professional Repair & Optimization for Gas Heaters & Heat Pumps",
            "description": "Your pool is an investment, but a cold pool is just a landscape feature. We analyze the entire combustion or refrigeration cycle to ensure your water hits the perfect temperature, every single time.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_4.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Swim Season Extension", "value": 10, "suffix": " Months" },
            { "label": "Energy Efficiency Gain", "value": 15, "suffix": "%" },
            { "label": "Heating Speed Increase", "value": 25, "suffix": "%" },
            { "label": "Titanium Warranty", "value": 15, "suffix": " Years" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "The Engineered Installation Process",
            "content": "We don’t just swap units. We follow a strict 5-step engineering workflow to ensure a 15-year lifespan.",
            "steps": [
                {
                    "title": "1. Thermal Load Calculation",
                    "description": "We analyze surface area and wind exposure to ensure your unit is perfectly sized—not guessed."
                },
                {
                    "title": "2. Hydraulic Flow Optimization",
                    "description": "We utilize schedule-80 CPVC piping to prevent short-cycling that destroys compressors."
                },
                {
                    "title": "3. Gas & Electrical Precision",
                    "description": "We verify gas meter capacity and install industrial-grade surge protectors for sensitive control boards."
                },
                {
                    "title": "4. Chemical Corrosion Defense",
                    "description": "We install specialized chemical traps and one-way valves to protect your heater from back-flowing chlorine."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Case Study: Stopping the '3-Year Death Cycle'",
            "content": "A local homeowner was on their third heater in 7 years. We discovered a plumbing design flaw causing chlorine back-siphonage. By installing a Titanium Heat Exchanger and a Chemical Trap loop, we re-engineered their pad for a 15-year horizon.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (System Types) ---
        "SystemTypes": [
            {
                "title": "Electric Heat Pumps",
                "text": "Low-cost operation that pulls heat from the air. Best for maintaining a constant 85°F all season.",
                "image": ICONS.HEAT_PUMP
            },
            {
                "title": "Gas Heaters",
                "text": "Heat on demand using Natural Gas or Propane. Perfect for heating spas quickly for weekend parties.",
                "image": ICONS.GAS
            },
            {
                "title": "Hybrid Systems",
                "text": "Combines Heat Pump efficiency with Gas Heater 'kick' for total control in any weather condition.",
                "image": ICONS.HYBRID
            },
            {
                "title": "Corrosion Protection",
                "text": "Titanium heat exchangers and zinc sacrificial anodes to defend against salt-water systems.",
                "image": ICONS.CORROSION
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Protect your swim season and your bottom line.",
            "tips": [
                "Descaling: Minerals bake onto your heat exchanger. A precision flush restores thermal conductivity.",
                "Sanitization: Spiders and rodents nest in burner trays. We clean orifices to ensure a clean blue flame.",
                "Coil Hygiene: For heat pumps, we use non-acidic cleaners to brighten fins and ensure airflow.",
                "The Night Blanket: Use a solar cover at night to prevent losing 70% of your heat to the air."
            ],
            "footerContent": {
                "preLink": "Book your ",
                "linkUrl": "/maintenance",
                "linkText": "Seasonal Start-Up Wellness Visit"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving the First Coast",
            "regions": [
                { "name": "Duval County", "areas": "Jacksonville, Jax Beach, Atlantic Beach, Neptune Beach, Mandarin, Riverside, San Marco" },
                { "name": "Clay County", "areas": "Fleming Island, Orange Park, Middleburg, Green Cove Springs, Oakleaf Plantation" },
                { "name": "St. Johns County", "areas": "Ponte Vedra, Nocatee, St. Augustine, Julington Creek, World Golf Village" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "How much does it cost to heat my pool?",
                "answer": "Electric Heat Pumps usually cost $100–$200/mo. Gas heaters are 'on-demand' and cost $10–$25 per hour depending on fuel prices."
            },
            {
                "question": "Why is my heater showing a 'Low Flow' or 'FLO' code?",
                "answer": "This usually means a dirty filter or clogged pump basket is restricting pressure. If the filter is clean, your pressure switch may need calibration."
            },
            {
                "question": "Is my heater leaking water or just condensation?",
                "answer": "If it leaks only while running, it’s likely condensation. If there is a puddle while off, your heat exchanger may have corroded."
            },
            {
                "question": "How long does it take to warm up the pool?",
                "answer": "Gas heaters raise temp 1–3 degrees per hour. Heat pumps are slower, typically gaining 3–5 degrees per day."
            },
            {
                "question": "Can I use a heater with a salt-water pool?",
                "answer": "Yes, but you MUST have a Titanium Heat Exchanger. Standard copper will be eaten by the salt in a few seasons."
            },
            {
                "question": "Why is my gas heater making a 'banging' sound?",
                "answer": "This is 'liming.' Calcium scale buildup traps water that turns to steam. You need a Professional Descaling Flush before pipes burst."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Pool Heater Repair & Installation",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-ductless-mini-split",
        "isActive": true,
        "slug": "ductless-mini-split-installation",
        "name": "Ductless Mini-Splits",
        "image": "ICONS.SMART_HOME",

        // --- META & CARD ---
        "cardTitle": "High-Efficiency Ductless Solutions",
        "cardDescription": "Surgical cooling precision for 'hot spots,' historic homes, and new additions. Eliminate leaky ductwork and slash energy costs with targeted zonal comfort.",
        "cardImage": "https://pryvw6vsbf7zfgtoyrmgbwvtqm0kcphn.lambda-url.us-east-2.on.aws/AlwaysOnAir/images/1770644036309-image.png",
        "cardButtonText": "Get Ductless Quote",
        "isCallNow": false,

        "seoTitle": "Expert Ductless Mini-Split Installation Jacksonville | Always On Air AC",
        "seoDescription": "Specialized ductless mini-split installation in Jacksonville, Ponte Vedra, & Nocatee. High-efficiency zonal cooling for historic homes, garages, and additions.",

        // --- HERO ---
        "hero": {
            "title": "High-Efficiency Ductless Heating & Cooling Solutions for the 904",
            "subtitle": "Precision Zonal Comfort. Zero Ductwork Hassle.",
            "description": "Whether you're battling humidity at Jax Beach, renovating a historic Riverside property, or cooling a Nocatee addition, our ductless solutions provide surgical cooling precision exactly where you need it most.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_5.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/1770644036309-image.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Energy Bill Savings", "value": 30, "suffix": "%" },
            { "label": "Operating Noise", "value": 19, "suffix": " dB" },
            { "label": "Installation Time", "value": 1, "suffix": " Day" },
            { "label": "Tax Credit Eligibility", "value": 2000, "prefix": "$" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "The Always On Air Engineering Standard",
            "content": "Installing a mini-split is a surgical process involving high-vacuum protocols and precision architectural placement.",
            "steps": [
                {
                    "title": "1. Advanced Load Design",
                    "description": "We perform a Manual J calculation for the specific room to ensure your unit pulls maximum humidity without 'short-cycling'."
                },
                {
                    "title": "2. Architectural Mapping",
                    "description": "We place the indoor head to eliminate 'dead zones' and route exterior lines using UV-rated architectural covers to maintain HOA compliance."
                },
                {
                    "title": "3. Triple Evacuation Protocol",
                    "description": "We pull a deep vacuum to 500 microns to remove every trace of moisture, preventing compressor failure in our salt-air environment."
                },
                {
                    "title": "4. Smart Commissioning",
                    "description": "We verify the 'Delta-T' temperature split and sync your system with Wi-Fi for smartphone humidity and temperature control."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Case Study: The Nocatee 'Hot Room' Hero",
            "content": "In a 3,200 sq. ft. modern home, a bonus room over the garage stayed 8 degrees warmer than the house. We installed a single-zone inverter system with a surgical 3-inch wall penetration and painted Line-Hide covers. The office now stays at a perfect 72°F while lowering the overall home energy usage.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (System Types) ---
        "SystemTypes": [
            {
                "title": "Multi-Zone Retrofit",
                "text": "One outdoor condenser running up to five indoor units. Ideal for whole-home cooling in historic San Marco bungalows.",
                "image": ICONS.MINI_SPLIT
            },
            {
                "title": "Inverter Technology",
                "text": "Systems ramp up and down like a dimmer switch, constantly scrubbing humidity without 'on/off' temperature swings.",
                "image": ICONS.HEAT_PUMP
            },
            {
                "title": "Gold Fin™ Protection",
                "text": "Specialized anti-corrosive coatings essential for our clients at Jax Beach and Ponte Vedra to prevent salt-air damage.",
                "image": ICONS.CORROSION
            },
            {
                "title": "Ceiling Cassettes",
                "text": "Recessed indoor heads that sit flush with the ceiling for a near-invisible, professional-grade finish.",
                "image": ICONS.AIRFLOW
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Protect your ductless investment in the Jacksonville humidity.",
            "tips": [
                "The Two-Week Filter Rule: Rinse your washable filters every two weeks. Clogged screens are the #1 cause of JEA bill spikes.",
                "Bio-Film Defense: Once a year, have us flush your drain line. Algae slime in our 90% humidity causes 90% of indoor leaks.",
                "Salt Spray Rinse: Coastal residents should gently rinse the outdoor unit with fresh water monthly to remove salt buildup.",
                "Use 'Dry Mode': On 75-degree humid days, run 'Dry Mode' to focus on dehumidification without over-cooling the room."
            ],
            "footerContent": {
                "preLink": "Join the ",
                "linkUrl": "/maintenance",
                "linkText": "Always On Maintenance Club"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving Every Corner of the Bold City",
            "regions": [
                { "name": "Historic Districts", "areas": "Riverside, Avondale, San Marco, Springfield (Surgical Retrofits)" },
                { "name": "Coastal Communities", "areas": "Ponte Vedra, Atlantic Beach, Neptune Beach, Jax Beach (Corrosion Defense)" },
                { "name": "Master-Planned Suburbs", "areas": "Nocatee, eTown, Julington Creek, Mandarin (Zonal Comfort)" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "Can a ductless system replace my central AC?",
                "answer": "Yes. A 'Whole-Home Retrofit' allows you to scrap leaky ductwork entirely, providing dedicated temperature control for every room."
            },
            {
                "question": "Will it look 'ugly' on the outside of my house?",
                "answer": "Not with Always On Air. We use architectural Line-Hide covers that can be painted to match your home’s exterior and meet strict HOA standards."
            },
            {
                "question": "Do these units provide heat during our rare North Florida freezes?",
                "answer": "Absolutely. These are high-efficiency heat pumps that provide warmth even when temps drop into the 30s or 20s, much more efficiently than electric strips."
            },
            {
                "question": "How long does the installation take?",
                "answer": "Most single-zone installations are completed in one day. Complex multi-zone whole-home projects typically take 2 to 3 days."
            },
            {
                "question": "Is there a tax credit available?",
                "answer": "Yes. Under the IRA, high-efficiency heat pump installations can qualify for federal tax credits up to $2,000. We provide all necessary AHRI certificates."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Ductless Mini-Split Installation",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Jacksonville", "Duval County", "St. Johns County", "Clay County"]
        }
    },
    {
        "id": "srv-emergency-ac-repair",
        "isActive": true,
        "slug": "emergency-ac-repair-jacksonville",
        "name": "Emergency AC Repair",
        "image": "ICONS.EMERGENCY_COOLING",

        // --- META & CARD ---
        "cardTitle": "24/7 Rapid Response Cooling Restoration",
        "cardDescription": "When the Jacksonville humidity spikes, an AC breakdown is a safety risk. We provide engineering-grade emergency repairs to get your home back to 72°F fast.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Call Emergency Dispatch",
        "isCallNow": true,

        "seoTitle": "Emergency AC Repair Jacksonville | 24/7 HVAC Service Always On Air AC",
        "seoDescription": "Rapid 24/7 emergency AC repair in Jacksonville, Nocatee, & Ponte Vedra. We fix blown capacitors, slime clogs, and coastal corrosion shorts. No-surprise pricing.",

        // --- HERO ---
        "hero": {
            "title": "Rapid Response to Keep Your Family Safe and Your Home 'Always On'",
            "subtitle": "24/7 Emergency AC Repair & Service in Jacksonville",
            "description": "In the 904 heat, an AC breakdown isn’t an inconvenience—it’s an emergency. When temperatures climb past 80°F, you need a local expert equipped to handle 'No-AC' situations on the First Coast immediately.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_6.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Response Window", "value": 60, "suffix": " Mins or Less" },
            { "label": "Availability", "value": 24, "suffix": "/7/365" },
            { "label": "Fix Rate", "value": 85, "suffix": "% Same Day" },
            { "label": "Service Radius", "value": 50, "suffix": " Miles" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "The Always On Emergency Restoration Process",
            "content": "A disciplined, 6-step engineering workflow designed to stabilize your home environment and protect your equipment.",
            "steps": [
                {
                    "title": "1. Mobile Warehouse Dispatch",
                    "description": "We arrive with a 'mobile warehouse' stocked with the specific high-temp capacitors and motors that fail in the 904 climate."
                },
                {
                    "title": "2. High-Voltage Safety Audit",
                    "description": "We verify electrical integrity and check for scorched wiring or standing water before resetting any safety switches."
                },
                {
                    "title": "3. Precision Digital Diagnostic",
                    "description": "We use digital manifolds and multimeters to measure exact amperage and refrigerant pressures. No guessing—just data."
                },
                {
                    "title": "4. Fix & Commissioning",
                    "description": "We restore cooling to factory specs, verify the Delta-T temperature drop, and ensure humidity is being actively removed."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Emergency Spotlight: The 'Sunday Scorch' in Nocatee",
            "content": "During a graduation party with 25 guests, the AC cut out. We arrived in 45 minutes, brought the thermal-overloaded compressor back to safe temps, and installed a USA-made 440V high-temp capacitor. The home returned to 72°F before dinner was served.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (Common Emergencies) ---
        "SystemTypes": [
            {
                "title": "Capacitor Blowouts",
                "text": "The 'battery' of your unit pops during heatwaves. We replace with heavy-duty parts rated for Florida's 140°F cabinet temps.",
                "image": ICONS.ELECTRICAL
            },
            {
                "title": "The 'Slime' Lockout",
                "text": "90% humidity creates algae clogs. We use high-pressure CO2 to blow out clogs and treat with industrial antimicrobials.",
                "image": ICONS.IAQ
            },
            {
                "title": "Coastal Electrical Shorts",
                "text": "Salt air pits and welds contactors shut. We use specialized corrosion-resistant components to stop the 'burnt wire' smell.",
                "image": ICONS.CORROSION
            },
            {
                "title": "Frozen Coils",
                "text": "Often caused by low refrigerant or dirt. We thaw, leak-test, and top-off to prevent compressor 'slugging'.",
                "image": ICONS.REFRIGERANT
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "Emergency Survival Advice",
            "subtitle": "What to do while you wait for our technician.",
            "tips": [
                "The 'Turn It Off' Rule: If the system is humming but not cooling, turn it off at the breaker to save your compressor.",
                "Manage Humidity: Keep blinds closed and avoid using the stove or taking hot showers to prevent 'sauna' conditions.",
                "The Ice Warning: If you see ice, set your fan to 'ON' (not Cool) for 3-4 hours so we can work on it when we arrive.",
                "Check the Switch: Check your drain pan; if it's full of water, your safety float switch is doing its job to prevent a flood."
            ],
            "footerContent": {
                "preLink": "Avoid the next crisis with our ",
                "linkUrl": "/maintenance",
                "linkText": "VIP Preventative Maintenance"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Rapid Response from the St. Johns River to the Atlantic",
            "regions": [
                { "name": "The Beaches", "areas": "Jax Beach, Neptune Beach, Ponte Vedra (Salt-Air Specialists)" },
                { "name": "St. Johns County", "areas": "Nocatee, SilverLeaf, Shearwater, Julington Creek (High-Demand Zones)" },
                { "name": "Historic Heart", "areas": "San Marco, Riverside, Avondale, Ortega (Historic Plumbing/Drain Experts)" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "How long can my home stay safe without AC?",
                "answer": "In 90% humidity, indoor heat index levels can become dangerous for pets and the elderly in as little as 3 to 4 hours."
            },
            {
                "question": "Why did my AC break on the hottest day of the year?",
                "answer": "Physics. Heat pushes weak components like capacitors past their thermal limits—internal cabinet temps can hit 140°F in July."
            },
            {
                "question": "Can I jump-start my outdoor fan with a stick?",
                "answer": "No. This bypasses a safety failure and creates an extreme electrical load that can permanently seize your motor or cause a fire."
            },
            {
                "question": "Is emergency service more expensive at night?",
                "answer": "At Always On Air, we use transparent flat-rate pricing. You'll know the cost of the repair before we start, even at midnight."
            },
            {
                "question": "My AC is blowing air, but it's not cold. Is that an emergency?",
                "answer": "Yes. It usually indicates a refrigerant leak or compressor failure. Turn it off to prevent the system from freezing into a block of ice."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Emergency AC Repair",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-heat-pump-jax",
        "isActive": true,
        "slug": "heat-pump-repair-installation",
        "name": "Heat Pump Services",
        "image": "ICONS.HEAT_PUMP",
        "cardTitle": "Year-Round Efficiency & Comfort",
        "cardDescription": "The gold standard for the First Coast. Heat pumps provide powerful cooling, surgical dehumidification, and cost-effective heating without the 'toaster-coil' utility bill spike.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Upgrade to Heat Pump",
        "isCallNow": false,
        "seoTitle": "Heat Pump Repair & Installation Jacksonville | Always On Air AC",
        "seoDescription": "Expert heat pump services in Jacksonville. High-efficiency variable-speed installs, salt-air corrosion protection, and precision repairs for Duval & St. Johns Counties.",
        "hero": {
            "title": "One System. Year-Round Comfort.",
            "subtitle": "Jacksonville’s Experts in High-Efficiency Heat Pump Technology",
            "description": "In Northeast Florida, heat pumps are the gold standard. They keep you frost-free during a St. Johns cold snap and ice-cold during a Mandarin heatwave, all while using significantly less energy than traditional electric heating.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_7.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },
        "stats": [
            {
                "label": "Heating Efficiency",
                "value": 300,
                "suffix": "%+"
            },
            {
                "label": "Energy Bill Savings",
                "value": 30,
                "suffix": "%"
            },
            {
                "label": "Humidity Target",
                "value": 45,
                "suffix": "% RH"
            },
            {
                "label": "Lifespan with Maintenance",
                "value": 15,
                "suffix": " Years"
            }
        ],
        "process": {
            "title": "The Always On Air AC Installation Standard",
            "content": "Precision engineering from blueprints to final commissioning. We don't just 'swap boxes'; we design systems.",
            "steps": [
                {
                    "title": "1. Manual J Load Calculation",
                    "description": "We analyze your insulation, windows, and square footage to determine the exact BTU capacity required to dehumidify properly."
                },
                {
                    "title": "2. Matched System Design",
                    "description": "We pair indoor and outdoor units to achieve the manufacturer’s rated SEER2 and HSPF2 levels, maximizing efficiency."
                },
                {
                    "title": "3. Deep Vacuum Protocol",
                    "description": "We pull a vacuum down to 500 microns to ensure a surgically clean refrigerant circuit, preventing future compressor failure."
                },
                {
                    "title": "4. Performance Audit",
                    "description": "We measure Delta-T, verify airflow CFM, and coordinate the final county inspection to protect your home's value."
                }
            ]
        },
        "stories": {
            "title": "Featured Project: High-Efficiency Coastal Upgrade",
            "content": "In Ponte Vedra Beach, we replaced a crumbling builder-grade unit with a variable-speed heat pump featuring Gold Fin™ technology. The home now maintains a crisp 48% humidity level, allowing the owners to feel cooler at 75°F than they previously did at 70°F, while slashing their JEA bill by 28%.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },
        "SystemTypes": [
            {
                "title": "Variable-Speed Inverters",
                "text": "Adjusts speed in 1% increments to maintain a steady temperature and pull maximum moisture out of the air.",
                "image": ICONS.HEAT_PUMP
            },
            {
                "title": "Dual-Fuel (Hybrid)",
                "text": "Combines electric heat pump efficiency with a gas furnace backup for the ultimate comfort in extreme cold snaps.",
                "image": ICONS.HYBRID
            },
            {
                "title": "Ductless Mini-Splits",
                "text": "Independent temperature control for room additions or historic homes with limited attic space.",
                "image": ICONS.MINI_SPLIT
            },
            {
                "title": "Coastal Armor",
                "text": "Units specified with Blue Fin or Gold Fin epoxy coatings to repel salt-air corrosion in beach communities.",
                "image": ICONS.CORROSION
            }
        ],
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Maximize lifespan in the Florida humidity.",
            "tips": [
                "The AUTO Fan Rule: Always keep your fan on 'AUTO.' The 'ON' setting blows moisture back into your house from the wet coil.",
                "The 20% Rule: Never close more than 20% of your vents. It creates static pressure that can freeze your coils and kill the motor.",
                "Pre-Storm Cooling: Before a Jacksonville storm, pre-cool your house 3 degrees and turn the system off to avoid surge damage.",
                "Winter Soil Check: After heavy rain, ensure the soil hasn't shifted and tilted your outdoor pad, which can cause refrigerant leaks."
            ],
            "footerContent": {
                "preLink": "Sign up for our ",
                "linkUrl": "/maintenance",
                "linkText": "Bi-Annual Performance Tune-Up"
            }
        },
        "neighborhoods": {
            "headline": "Premier HVAC Services for Jacksonville’s Top Neighborhoods",
            "regions": [
                {
                    "name": "Coastal Communities",
                    "areas": "Ponte Vedra Beach, Atlantic Beach, Neptune Beach, Jacksonville Beach (Salt-Air Specialists)"
                },
                {
                    "name": "Historic Districts",
                    "areas": "San Marco, Riverside, Avondale, Ortega (Architectural Integrity Experts)"
                },
                {
                    "name": "Planned Suburbs",
                    "areas": "Nocatee, Mandarin, Fleming Island, Julington Creek (Variable-Speed Specialists)"
                }
            ]
        },
        "faqList": [
            {
                "question": "Why is my outdoor unit 'smoking' in the winter?",
                "answer": "It’s actually steam! This is 'Defrost Mode,' where the system melts ice off the outdoor coils to keep heating efficiently."
            },
            {
                "question": "What is 'Emergency Heat' and why is it so expensive?",
                "answer": "It turns on electric heat strips (like a giant toaster). Use it only if the heat pump fails, as it can triple your utility bill."
            },
            {
                "question": "My thermostat says 72°F, but I still feel 'sticky.' Why?",
                "answer": "Humidity is the culprit. An oversized system cools too fast to remove moisture. We recommend variable-speed upgrades to drop RH to 45%."
            },
            {
                "question": "How long does a heat pump last in Florida?",
                "answer": "Typically 10-12 years due to 365-day use. However, coastal properties need specialized coatings to survive salt air beyond 5-7 years."
            },
            {
                "question": "Does a smart thermostat really help a heat pump?",
                "answer": "Yes. Smart thermostats like Ecobee manage the 'staging' of your compressor much more efficiently than standard models, saving money automatically."
            }
        ],
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Heat Pump Installation and Repair",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": [
                "Duval County",
                "Clay County",
                "St. Johns County"
            ]
        }
    },
    {
        "id": "srv-heating-maintenance",
        "isActive": true,
        "slug": "heating-maintenance-jacksonville",
        "name": "Heating Maintenance",
        "image": "ICONS.MAINTENANCE",

        // --- META & CARD ---
        "cardTitle": "Precision Heating Tune-Ups",
        "cardDescription": "Don't wait for the first freeze. Our specialized maintenance clears 'summer dust', prevents fire hazards, and ensures your heat pump is ready to perform.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Schedule Tune-Up",
        "isCallNow": false,

        "seoTitle": "Heating Maintenance & Tune-Ups Jacksonville | Always On Air AC",
        "seoDescription": "Expert heating maintenance in Jacksonville, Mandarin, & Nocatee. 21-point safety inspections for heat pumps and electric furnaces. Prevent 'First Freeze' failures.",

        // --- HERO ---
        "hero": {
            "title": "High-Performance Heating Services to Keep Your First Coast Home 'Always On'",
            "subtitle": "Jacksonville Heating Maintenance & Tune-Ups",
            "description": "In Jacksonville, heaters sit dormant for 10 months. This inactivity leads to dust accumulation, seized valves, and electrical corrosion. We provide specialized maintenance to ensure your system is safe, efficient, and ready when the temperature drops.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_8.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Safety Checkpoints", "value": 21, "suffix": " Point Audit" },
            { "label": "Winter Bill Savings", "value": 20, "suffix": "%" },
            { "label": "Failure Prevention", "value": 90, "suffix": "%" },
            { "label": "Certified Techs", "value": 100, "suffix": "% NATE" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "The Always On Engineering Standard",
            "content": "We don't just 'check' your heater; we return it to factory specifications using a data-driven approach.",
            "steps": [
                {
                    "title": "1. Cold Start Audit",
                    "description": "We use NIST-calibrated thermal imagers to identify 'dead' heating elements and electrical hot spots before they fail."
                },
                {
                    "title": "2. High-Amperage Tightening",
                    "description": "Heating draws more power than cooling. We torque every terminal to prevent 'arcing' and electrical fires during heavy winter loads."
                },
                {
                    "title": "3. Defrost Stress Test",
                    "description": "We force a simulated freeze to verify your heat pump can shed ice properly, preventing your outdoor unit from becoming a block of ice."
                },
                {
                    "title": "4. Safety & Sequence Verification",
                    "description": "We test limit switches and sequencers to ensure your 'Emergency Heat' doesn't overload your home's electrical panel."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Featured Project: The 'Frozen' Heat Pump Rescue",
            "content": "A Mandarin homeowner found their unit encased in a thick block of ice. We identified a failed defrost board and corroded sensors. By de-icing the unit and calibrating the defrost timing, we restored vent temps from 68°F to a toasty 98°F and prevented a massive JEA bill spike.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (System Types) ---
        "SystemTypes": [
            {
                "title": "Air-Source Heat Pumps",
                "text": "The Jax standard. We focus on reversing valves and defrost boards—the 'brains' of your winter comfort.",
                "image": ICONS.HEAT_PUMP
            },
            {
                "title": "Electric Furnaces",
                "text": "We inspect sequencers and high-resistance heat strips to ensure safe operation without fire risks.",
                "image": ICONS.ELECTRICAL
            },
            {
                "title": "Ductless Mini-Splits",
                "text": "Deep coil scrubbing to remove 'summer grime' that causes musty smells during the first heating cycle.",
                "image": ICONS.MINI_SPLIT
            },
            {
                "title": "Coastal Shield Service",
                "text": "Extra anti-corrosive treatments for Jax Beach and Ponte Vedra units exposed to salt spray year-round.",
                "image": ICONS.CORROSION
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Expert tips to avoid a 'First Freeze' emergency.",
            "tips": [
                "The October Test: Turn your heat on for 20 mins in October with windows open to burn off dust before it gets cold.",
                "EM Heat Warning: Use 'Emergency Heat' ONLY if the pump is broken. It's 3-4x more expensive than standard heating.",
                "The 2-Foot Rule: Keep fallen leaves and winter weeds 2 feet away from your outdoor unit so it doesn't ice over.",
                "Listen for the Buzz: A persistent buzz can mean a failing contactor or a struggling reversing valve. Catch it now."
            ],
            "footerContent": {
                "preLink": "Don't wait for the freeze. ",
                "linkUrl": "/maintenance-club",
                "linkText": "Join our Maintenance Club"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving Every Climate Pocket in the 904",
            "regions": [
                { "name": "Historic Districts", "areas": "Riverside, Avondale, San Marco (Old Grid & Historic Furnace Experts)" },
                { "name": "Frost-Prone Areas", "areas": "Mandarin, Julington Creek, Fruit Cove (Defrost & Humidity Management)" },
                { "name": "New Developments", "areas": "Nocatee, SilverLeaf, Shearwater (Zonal Heating & Smart Controls)" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "Why does my heater smell like it's burning?",
                "answer": "Dust settles on the 'heat strips' during 10 months of idleness. It usually burns off in 20-30 minutes. If it persists, turn it off and call us."
            },
            {
                "question": "My outdoor unit is covered in white frost. Is it broken?",
                "answer": "Light frost is normal. Your system has a 'Defrost Mode' to melt it. However, if it's a thick block of ice that won't melt, your defrost board has failed."
            },
            {
                "question": "Why is my heater blowing 'cool' air?",
                "answer": "Heat pumps blow air at 85-95°F. Since your body is 98.6°F, it can feel cool, but it's still heating. If it's the same temp as the room, the reversing valve is likely stuck."
            },
            {
                "question": "Is a tune-up worth it if I only use heat for two weeks?",
                "answer": "Yes. Florida's salty air corrodes connections while they sit idle. Maintenance prevents electrical fires and 'sticker shock' utility bills."
            },
            {
                "question": "What happens during a heating tune-up?",
                "answer": "We clean the heat strips, test the defrost cycle, tighten high-amperage electrical connections, and calibrate your thermostat for heat pump efficiency."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Heating Maintenance",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-hvac-repairs",
        "isActive": true,
        "slug": "hvac-repair-jacksonville",
        "name": "HVAC Repair Services",
        "image": "ICONS.REPAIR",

        // --- META & CARD ---
        "cardTitle": "HVAC Repairs: Fast Fixes. Honest Advice.",
        "cardDescription": "Precision diagnostics that find the source, not just the symptom. No hidden fees, just honest service to get your home back to perfect comfort.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Schedule Repair",
        "isCallNow": true,

        "seoTitle": "Expert AC & HVAC Repair Jacksonville | Always On Air AC",
        "seoDescription": "Professional HVAC repair in Jacksonville, Duval, and St. Johns. 24/7 emergency service, flat-rate pricing, and forensic diagnostics for all major AC brands.",

        // --- HERO ---
        "hero": {
            "title": "HVAC Repairs: Fast Fixes. Honest Advice.",
            "subtitle": "Precision Engineering. Honest Service. Perfect Comfort.",
            "description": "A broken HVAC system is a disruption to your life. Whether your AC is blowing warm air or your furnace is making strange noises, you need a licensed professional who values your time as much as your comfort.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_9.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Repair Success Rate", "value": 98, "suffix": "%" },
            { "label": "Diagnostic Accuracy", "value": 100, "suffix": "%" },
            { "label": "Parts Warranty", "value": 10, "suffix": " Year" },
            { "label": "Average Arrival Time", "value": 60, "suffix": " Mins" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "Our Precision Repair Methodology",
            "content": "A 'patch job' isn't a repair. We follow a strict engineering workflow to restore factory-spec performance.",
            "steps": [
                {
                    "title": "1. Forensic Diagnostics",
                    "description": "We analyze static pressure, airflow (CFM), and electrical load to find out WHY the part failed, preventing repeat breakdowns."
                },
                {
                    "title": "2. Component Matching",
                    "description": "We ensure all replacement parts, from TXVs to motors, are perfectly matched to your system’s original engineering parameters."
                },
                {
                    "title": "3. Permitted Safety",
                    "description": "For major repairs like compressors, we pull all necessary mechanical permits to protect your insurance and family safety."
                },
                {
                    "title": "4. Performance Commissioning",
                    "description": "We recalibrate your system’s control board and thermostat to ensure new parts communicate perfectly with the old."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Case Study: Advanced Leak Detection & Restoration",
            "content": "A local customer was told they 'just needed a recharge' every summer. We performed a Nitrogen Pressure Decay Test and found a microscopic leak in a factory solder joint. By replacing the coil and upgrading the TXV, we restored a crisp 20°F Delta-T and saved the customer from a $5,000 full replacement.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (Common Failures) ---
        "SystemTypes": [
            {
                "title": "Electrical Restoration",
                "text": "Replacement of failed dual-run capacitors, heavy-duty contactors, and control boards using silver-point components.",
                "image": ICONS.ELECTRICAL
            },
            {
                "title": "Refrigerant Circuit",
                "text": "Electronic leak detection, Thermal Expansion Valve (TXV) replacement, and precision charging within ±1 ounce.",
                "image": ICONS.REFRIGERANT
            },
            {
                "title": "Airflow Corrections",
                "text": "Blower motor replacements, fan balancing, and deep evaporator coil cleaning to stop system 'suffocation'.",
                "image": ICONS.AIRFLOW
            },
            {
                "title": "System Hardening",
                "text": "Installation of industrial-grade surge protectors and hard-start kits to protect your compressor's windings.",
                "image": ICONS.HARDENING
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Stop small parts from killing expensive motors.",
            "tips": [
                "The $100 Rule: Most $2,000 motor failures start with a $100 capacitor failing. Check your electrical vital signs annually.",
                "Deep-Fin Washing: A dirty outdoor coil forces the compressor to pull more amps. A chemical wash can slash your bill by 20%.",
                "The Ice Warning: If you see ice, your system is 'suffocating'. Turn it off immediately to prevent compressor 'slugging'.",
                "Float Switch Safety: We treat pans with industrial algaecide to prevent the #1 cause of interior water damage—clogged drains."
            ],
            "footerContent": {
                "preLink": "Avoid emergency repairs by joining our ",
                "linkUrl": "/maintenance",
                "linkText": "Comfort Club Maintenance Plan"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Expert HVAC Solutions Across the First Coast",
            "regions": [
                { "name": "Duval County", "areas": "Jacksonville, Mandarin, Riverside, San Marco, Jax Beach, Southside" },
                { "name": "Clay County", "areas": "Orange Park, Fleming Island, Middleburg, Green Cove Springs" },
                { "name": "St. Johns County", "areas": "St. Augustine, Ponte Vedra, Nocatee, Julington Creek" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "Why is my AC running but the house isn't getting cooler?",
                "answer": "This usually indicates airflow restriction (check your filter!) or a refrigerant leak. Turn the system off to prevent permanent compressor damage."
            },
            {
                "question": "How much does a diagnostic visit cost?",
                "answer": "Our diagnostic covers a full forensic analysis using high-end digital tools. We provide a flat-rate quote before any work begins."
            },
            {
                "question": "My unit is making a loud buzzing or shrieking sound. Is that bad?",
                "answer": "Yes. Buzzing is often an electrical component struggling, and shrieking is usually a failing bearing. Catching these early prevents total failure."
            },
            {
                "question": "Can you just 'top off' my refrigerant?",
                "answer": "We can, but if you're low, you have a leak. We prefer to find and fix the leak so you aren't wasting money on gas that will just disappear again."
            },
            {
                "question": "Will repairing my old unit affect its warranty?",
                "answer": "We use OEM parts to ensure your manufacturer warranty remains valid and handle the paperwork to make sure you get the credit you're owed."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "HVAC Repair",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-iaq-solutions",
        "isActive": true,
        "slug": "indoor-air-quality-solutions",
        "name": "Indoor Air Quality",
        "image": "ICONS.PURIFIER",

        // --- META & CARD ---
        "cardTitle": "Advanced Indoor Air Quality Solutions",
        "cardDescription": "Turn your HVAC system into a hospital-grade air scrubber. We specialize in UV sanitization, active air purification, and high-efficiency filtration.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Breathe Cleaner Air",
        "isCallNow": false,

        "seoTitle": "Indoor Air Quality & UV Purification Jacksonville | Always On Air AC",
        "seoDescription": "Hospital-grade air purification in Jacksonville. UV-C lights, active air scrubbers, and MERV-13 filtration to eliminate mold, viruses, and allergens.",

        // --- HERO ---
        "hero": {
            "title": "Advanced Air Purification, UV Sanitization, and Filtration for Your Home",
            "subtitle": "Pure Air Solutions to Keep Your Family Safe and Your Home 'Always On'",
            "description": "Your indoor air can be 5x more polluted than the air outside. We provide hospital-grade IAQ solutions that neutralize pathogens at the source, ensuring every breath you take is clean, crisp, and safe.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_10.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Pathogen Reduction", "value": 99.9, "suffix": "%" },
            { "label": "Filter Surface Area", "value": 30, "suffix": "x Increase" },
            { "label": "Allergen Capture", "value": 95, "suffix": "%" },
            { "label": "Odor Neutralization", "value": 100, "suffix": "% Certified" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "Professional IAQ Installation Process",
            "content": "Precision engineering for the air you breathe. We ensure your system is purified without compromising your blower motor's lifespan.",
            "steps": [
                {
                    "title": "1. Static Pressure Audit",
                    "description": "We measure your system’s resistance to ensure adding high-MERV filtration won't 'choke' the motor and cause a freeze-up."
                },
                {
                    "title": "2. Strategic Component Placement",
                    "description": "UV lights are mounted over the wet evaporator coil to kill mold, while Air Scrubbers are placed in the supply plenum for even distribution."
                },
                {
                    "title": "3. Dedicated Power Integration",
                    "description": "We install independent transformers for IAQ hardware to protect your AC’s expensive logic board from electrical interference."
                },
                {
                    "title": "4. Hermetic Duct Sealing",
                    "description": "When installing media cabinets, we custom-fabricate transitions to ensure 100% of air passes through the filter with zero bypass."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Project Spotlight: The 'Allergy-Free Sanctuary'",
            "content": "A local family suffered from 'Year-Round Hay Fever' caused by microscopic mold on their AC coil and a collapsing 1-inch filter. We engineered a Triple-Threat system: UV-C sanitization, a 4-inch Media Cabinet, and an Active Air Scrubber. Within 48 hours, the family reported a complete end to morning congestion and musty odors.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (IAQ Arsenal) ---
        "SystemTypes": [
            {
                "title": "UV-C Germicidal Lights",
                "text": "The Sanitizers. Hospital-grade light that destroys the DNA of mold, bacteria, and 'Dirty Sock Syndrome' at the coil.",
                "image": ICONS.IAQ
            },
            {
                "title": "Active Air Scrubbers",
                "text": "The Purifiers. NASA-inspired technology that sends out oxidizing molecules to neutralize viruses on surfaces and in the air.",
                "image": ICONS.IAQ
            },
            {
                "title": "High-MERV Media Cabinets",
                "text": "The Shield. Deep-pleated 4-inch filters that capture 99% of particles (MERV 13-16) without 'strangling' your airflow.",
                "image": ICONS.IAQ
            },
            {
                "title": "Whole-Home Dehumidifiers",
                "text": "The Balancers. Keeps indoor humidity below 50% to kill dust mite populations and prevent mildew growth in carpets.",
                "image": ICONS.DEHUMIDIFIER
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Keep your home’s 'lungs' clean between professional visits.",
            "tips": [
                "The 12-Month Bulb Rule: UV bulbs glow blue long after they lose germicidal power. Replace your lamps every year.",
                "The 'Pop' Check: If you hear snapping from your ionizer, the needles are dirty and 'arcing'. Wipe them to restore purification.",
                "Humidity Threshold: Keep indoor RH between 45% and 55%. Above 60%, mold reproduces faster than any filter can catch it.",
                "Visual Load Audit: Check your 4-inch filter every 30 days. If it looks 'gray', it's increasing static pressure on your blower."
            ],
            "footerContent": {
                "preLink": "Ensure pure air with our ",
                "linkUrl": "/maintenance",
                "linkText": "Annual IAQ Wellness Visit"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving the First Coast",
            "regions": [
                { "name": "Duval County", "areas": "Jacksonville, Atlantic Beach, Neptune Beach, Mandarin, Riverside, San Marco" },
                { "name": "Clay County", "areas": "Orange Park, Fleming Island, Middleburg, Green Cove Springs, Oakleaf Plantation" },
                { "name": "St. Johns County", "areas": "St. Augustine, Ponte Vedra, Nocatee, Julington Creek, World Golf Village" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "Why can’t I just buy a high-MERV filter at the hardware store?",
                "answer": "Dense filters 'choke' blower motors not designed for them. We perform a Static Pressure Test to ensure your motor won't burn out."
            },
            {
                "question": "How do I know if my UV light is actually working?",
                "answer": "We install a specialized 'Sight Glass' porthole. If you see a soft blue glow, the lamp has power. Remember to replace it annually for potency."
            },
            {
                "question": "Does a UV light kill viruses like the Flu?",
                "answer": "Yes. UV-C light is proven to neutralize pathogens. When paired with an Active Air Scrubber, it significantly reduces the viral load in your home."
            },
            {
                "question": "Why does my house smell 'musty' when the AC turns on?",
                "answer": "This is 'Dirty Sock Syndrome' caused by bacteria on your damp coil. A UV-C Germicidal Light is the permanent cure for this growth."
            },
            {
                "question": "My house is always dusty no matter how much I clean. Why?",
                "answer": "You likely have Duct Leakage. Your AC is pulling unfiltered attic air into your living space. We can perform a 'Duct Audit' to seal those leaks."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Indoor Air Quality Solutions",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-duct-services",
        "isActive": true,
        "slug": "professional-duct-cleaning-sealing",
        "name": "Duct Services",
        "image": "ICONS.DUCT_SERVICES",

        // --- META & CARD ---
        "cardTitle": "Clean Ducts. Pure Air. Lower Bills.",
        "cardDescription": "High-performance duct sealing, HEPA cleaning, and custom air balancing. Stop cooling your attic and start breathing pure air.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png",
        "cardButtonText": "Schedule Duct Audit",
        "isCallNow": false,

        "seoTitle": "Professional Duct Cleaning & Sealing Jacksonville | Always On Air AC",
        "seoDescription": "Expert duct sealing, repair, and antimicrobial cleaning in Jacksonville. Fix hot spots, reduce dust, and lower energy bills with our engineered airflow solutions.",

        // --- HERO ---
        "hero": {
            "title": "Professional Duct Cleaning, Sealing & Repair | Airflow Experts in Jacksonville",
            "subtitle": "High-Performance Duct Sealing, Sanitization, and Custom Air Balancing",
            "description": "Your ductwork is the 'hidden highway' of your home. If those highways are cracked or dusty, your AC works twice as hard for half the comfort. We provide engineered solutions to fix leaks, eliminate dust, and balance your home's airflow.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_11.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Energy Loss Reduction", "value": 30, "suffix": "%" },
            { "label": "Airflow Balance Accuracy", "value": 2, "suffix": "°F Variance" },
            { "label": "Filtration Standard", "value": 100, "suffix": "% HEPA" },
            { "label": "Seal Longevity", "value": 20, "suffix": " Years" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "Our Professional Duct Installation Process",
            "content": "A duct installation isn't just about tubes; it's about fluid dynamics. We follow a rigorous 5-step process to ensure 100% comfort delivery.",
            "steps": [
                {
                    "title": "1. Manual D Engineering",
                    "description": "We calculate the exact CFM required for every room based on size and window exposure to ensure the system breathes perfectly."
                },
                {
                    "title": "2. Custom Plenum Fabrication",
                    "description": "We build galvanized steel or high-density plenums and seal them with fiber-reinforced mastic to eliminate air loss at the high-pressure source."
                },
                {
                    "title": "3. Straight-Run Layout",
                    "description": "We pull flex ducts tight and use heavy-duty hanging straps every 4 feet to prevent sags and kinks that act as speed bumps for airflow."
                },
                {
                    "title": "4. CFM Verification & Balance",
                    "description": "Using digital flow hoods, we measure the air at every vent and adjust manual dampers until every room stays at the exact target temperature."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Project Spotlight: The 'Attic Dust' Detox",
            "content": "A Jacksonville homeowner had a master bedroom 7 degrees warmer than the house and black 'ghosting' rings on their vents. We found a detached supply duct and a leaking return plenum sucking in hot attic air. After re-connecting the runs, applying armored mastic, and air balancing the system, the house reached 72°F instantly, and the AC now runs 3 hours less per day.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (Service Types) ---
        "SystemTypes": [
            {
                "title": "Mastic Sealing",
                "text": "We use fiber-reinforced 'liquid rubber' to create a permanent, airtight bond on joints—stopping the 'Attic Vacuum' effect.",
                "image": "ICONS.CERTIFIED"
            },
            {
                "title": "Air Balancing",
                "text": "Using flow hoods to tune manual dampers, ensuring air is 'pushed' to the back of the house and eliminating hot spots.",
                "image": "ICONS.INSTALL"
            },
            {
                "title": "HEPA Cleaning",
                "text": "Deep mechanical cleaning with antimicrobial fogging to kill mold spores and 'lock down' dust particles inside the duct liner.",
                "image": "ICONS.PURIFIER"
            },
            {
                "title": "R-8 Insulated Replacement",
                "text": "Replacing collapsed or 'sweating' builder-grade ducts with thick, high-efficiency R-8 insulation designed for Florida attics.",
                "image": "ICONS.HEATING"
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Protect your airflow between professional sealings.",
            "tips": [
                "The Register Reveal: Look for dark 'ghosting' rings on the ceiling around vents; it's a sign your ducts are pulling in dirty attic air.",
                "Avoid 'Grey Tape': Standard duct tape adhesive melts in 130°F Florida attics. Only use UL-181 rated foil tape or mastic for seals.",
                "The 20% Limit: Never close more than 20% of your vents. High static pressure can pop duct seams and freeze your AC coil.",
                "Furniture Clearance: Keep at least 8 inches of space between furniture and return air grilles to allow your system to 'inhale' properly."
            ],
            "footerContent": {
                "preLink": "Lower your bills today with a ",
                "linkUrl": "/contact",
                "linkText": "Professional Duct Audit"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving Jacksonville & Surrounding Neighborhoods",
            "regions": [
                { "name": "Duval County", "areas": "Jacksonville, Mandarin, Riverside, San Marco, Jax Beach, Northside" },
                { "name": "Clay County", "areas": "Orange Park, Fleming Island, Middleburg, Oakleaf Plantation, Lake Asbury" },
                { "name": "St. Johns County", "areas": "Ponte Vedra, Nocatee, St. Augustine, Julington Creek, World Golf Village" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "How do I know if my ducts are actually leaking?",
                "answer": "If you dust every 2 days, see dark rings around vents, or have rooms that stay 5+ degrees warmer than the rest of the house, you have leakage."
            },
            {
                "question": "Does duct cleaning actually work, or is it a scam?",
                "answer": "It works when done by HVAC pros using mechanical brushes and HEPA vacuums. Avoid '$99 specials' that only vacuum the registers."
            },
            {
                "question": "Will sealing my ducts really lower my electric bill?",
                "answer": "Yes. Most homes lose 20-30% of their air through leaks. Sealing them can save $30–$75 per month during peak Jacksonville summers."
            },
            {
                "question": "What is 'Air Balancing'?",
                "answer": "It's the process of tuning dampers to ensure every room gets the exact volume of air it needs to match the thermostat setting."
            },
            {
                "question": "Should I replace my ducts when getting a new AC?",
                "answer": "We highly recommend it. Putting a high-efficiency unit on old, leaky ducts is like putting a Ferrari engine in a car with flat tires."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Duct Cleaning, Sealing, and Repair",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-dehumidification",
        "isActive": true,
        "slug": "whole-home-dehumidifier-installation",
        "name": "Dehumidification",
        "image": "ICONS.DEHUMIDIFIER",

        // --- META & CARD ---
        "cardTitle": "Whole-Home Moisture Control",
        "cardDescription": "It’s not just the heat, it’s the humidity. Maintain a crisp, consistent 45-50% humidity level and protect your home from mold, dust mites, and 'clammy' air.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Dry Out My Home",
        "isCallNow": false,

        "seoTitle": "Whole-Home Dehumidifier Installation Jacksonville | Always On Air AC",
        "seoDescription": "Expert dehumidifier installation in Jacksonville, Clay, & St. Johns Counties. Control indoor humidity, prevent mold, and lower energy bills with integrated moisture control.",

        // --- HERO ---
        "hero": {
            "title": "It’s Not Just the Heat, It’s the Humidity.",
            "subtitle": "Protect Your Home and Your Health with Whole-Home Moisture Control",
            "description": "In Jacksonville, your AC often can't run long enough to pull moisture out of the air during 'shoulder seasons' or rainy days. We install integrated dehumidifiers that maintain a crisp 45-50% humidity level independently of your cooling system.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_11.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Moisture Removal", "value": 98, "suffix": " Pints/Day" },
            { "label": "Comfort Threshold", "value": 50, "suffix": "% RH" },
            { "label": "Utility Bill Savings", "value": 15, "suffix": "%" },
            { "label": "Mold Prevention", "value": 100, "suffix": "% Effective" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "Precision Moisture-Defense Installation",
            "content": "We don't just 'plug in' a unit; we engineer a bypass loop into your existing HVAC infrastructure.",
            "steps": [
                {
                    "title": "1. Psychrometric Analysis",
                    "description": "We measure the 'grains of moisture' in your air to accurately size the unit (Pints per day) for your specific square footage."
                },
                {
                    "title": "2. Hydraulic Integration",
                    "description": "We cut into your supply or return plenum to create a high-efficiency bypass loop for the dehumidifier to scrub the air."
                },
                {
                    "title": "3. Permanent Drainage",
                    "description": "We plumb a dedicated drain line directly into your home's wastewater system—no buckets to empty, ever."
                },
                {
                    "title": "4. Smart Humidistat Sync",
                    "description": "We wire the unit to a smart controller that allows your dehumidifier and blower to work in a perfect 'handshake' harmony."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Project Spotlight: The 'Sticky New Construction' Fix",
            "content": "A family in a modern, airtight Clay County home felt 'clammy' even at 70°F. We found their humidity at 68%, risking imminent mold growth. We installed a 98-pint integrated dehumidifier. Within 6 hours, humidity dropped to 48%. They now keep their thermostat at 74°F, feel cooler than before, and are saving 15% on their electric bill.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (System Types) ---
        "SystemTypes": [
            {
                "title": "Integrated Whole-Home",
                "text": "Installed directly into your ductwork to pull air from every room, dry it, and recirculate it through your existing vents.",
                "image": "ICONS.SMART_HOME"
            },
            {
                "title": "Smart Humidistat Controls",
                "text": "Digital sensors that allow you to set your 'Dryness Level' from your phone, independent of the temperature setting.",
                "image": "ICONS.INSTALL"
            },
            {
                "title": "Crawlspace Solutions",
                "text": "Heavy-duty units designed to protect the 'bones' of your home from wood rot, mildew, and structural dampness.",
                "image": "ICONS.HEATING"
            },
            {
                "title": "Corrosion-Resistant Armor",
                "text": "Specialized coatings for units at the Beaches to resist the salt-air 'pitting' common in Jax Beach and Ponte Vedra.",
                "image": "ICONS.CERTIFIED"
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "How to keep your home crisp and dry.",
            "tips": [
                "The Vinegar Flush: Pour white vinegar down the dehumidifier's drain line every 90 days to prevent algae sludge clogs.",
                "Rinse the Intake: Slide out the internal intake filter every 6 months. Most are permanent; just rinse, dry, and replace.",
                "The 12-Inch Rule: Ensure at least 12 inches of clearance around the machine. Storage stacked against it will 'suffocate' its drying power.",
                "Window Watch: If you see condensation (fogging) on the inside of your glass, your humidity is too high. Check your humidistat."
            ],
            "footerContent": {
                "preLink": "Lock in your comfort with a ",
                "linkUrl": "/contact",
                "linkText": "Clay County Humidity Audit"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving Jacksonville & Surrounding Neighborhoods",
            "regions": [
                { "name": "Duval County", "areas": "Jacksonville, Jax Beach, Atlantic Beach, Neptune Beach, Mandarin, San Marco" },
                { "name": "Clay County", "areas": "Orange Park, Fleming Island, Eagle Landing, Oakleaf Plantation, Middleburg" },
                { "name": "St. Johns County", "areas": "Ponte Vedra, Nocatee, St. Augustine, Julington Creek, Fruit Cove" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "Why do I need a dehumidifier if I already have AC?",
                "answer": "Your AC only removes moisture when it's actively cooling. On 75°F rainy days, your AC stays off, but the humidity stays high. Our units work independently 24/7."
            },
            {
                "question": "My house is a newer build; why does it feel so 'sticky'?",
                "answer": "Modern homes are built 'tight' for energy efficiency, trapping moisture from showers and cooking inside. Integrated dehumidifiers provide the missing air exchange."
            },
            {
                "question": "Will this system be loud?",
                "answer": "Not at all. We install them in attics or mechanical closets and use your home's existing ductwork to muffle the sound. It's whisper-quiet."
            },
            {
                "question": "Do I have to empty a water bucket every day?",
                "answer": "Absolutely not. We plumb the unit directly into your drainage system, so moisture is automatically sent outside without you lifting a finger."
            },
            {
                "question": "Can it really lower my electric bill?",
                "answer": "Yes. Dry air feels cooler. By maintaining 50% humidity, you can raise your thermostat by 3-5 degrees and feel just as comfortable, saving on cooling costs."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Whole-Home Dehumidifier Installation",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    },
    {
        "id": "srv-cooling-maintenance",
        "isActive": true,
        "slug": "ac-maintenance-cooling-tune-ups",
        "name": "Cooling Maintenance",
        "image": "ICONS.MAINTENANCE",

        // --- META & CARD ---
        "cardTitle": "High-Performance Cooling Tune-Ups",
        "cardDescription": "Engineering-grade maintenance designed for the First Coast. We combat 90% humidity and salt air to keep your home crisp and your bills low.",
        "cardImage": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png",
        "cardButtonText": "Schedule My Tune-Up",
        "isCallNow": false,

        "seoTitle": "AC Maintenance & Cooling Tune-Ups Jacksonville | Always On Air AC",
        "seoDescription": "Expert 21-point AC precision tune-ups in Jacksonville. Specialized salt-air protection, drain line sanitization, and efficiency audits for Duval & St. Johns Counties.",

        // --- HERO ---
        "hero": {
            "title": "High-Performance Cooling to Keep Your First Coast Home 'Always On'",
            "subtitle": "AC Maintenance & Cooling Tune-Ups in Jacksonville",
            "description": "In Jacksonville, your AC is a survival tool running nearly 300 days a year. With 90% humidity and corrosive salt air, a standard 'look-over' isn't enough. We provide engineered maintenance that ensures your system survives the grueling Florida summer.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/videos/always_on_air_6.mp4",
            "imageMobile": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_TechnicianaSecondImage.png"
        },

        // --- METRICS ---
        "stats": [
            { "label": "Energy Bill Reduction", "value": 15, "suffix": "%" },
            { "label": "Points Inspected", "value": 21, "suffix": " Point Audit" },
            { "label": "System Days Active", "value": 300, "suffix": " Days/Year" },
            { "label": "Lifespan Extension", "value": 5, "suffix": " Years" }
        ],

        // --- PROCESS ---
        "process": {
            "title": "Our Precision Cooling Maintenance Process",
            "content": "A step-by-step engineering audit to beat the Florida heat. We find the small details that prevent catastrophic failures.",
            "steps": [
                {
                    "title": "1. Baseline Diagnostics",
                    "description": "We use digital manifolds and thermal sensors to establish a 'breathing' baseline for your refrigerant pressures and Delta-T."
                },
                {
                    "title": "2. Tactical Drain Sanitization",
                    "description": "We use high-pressure CO2 flushes to clear 'algae slime' and treat pans with industrial antimicrobial strips to prevent indoor flooding."
                },
                {
                    "title": "3. Industrial Coil Restoration",
                    "description": "Using alkaline-based foaming agents, we lift salt spray and Jacksonville dirt from outdoor coils to restore maximum heat transfer."
                },
                {
                    "title": "4. Electrical Stress Test",
                    "description": "We measure capacitor microfarads and check contactors for 'pitting' to catch failures before they strand you in a 90-degree house."
                }
            ]
        },

        // --- STORIES ---
        "stories": {
            "title": "Featured Project: The 'Salt-Air Save' at Jax Beach",
            "content": "A coastal residence was struggling with 68% indoor humidity and spiked JEA bills. We identified caked salt-crust on the condenser and pitted contactors. After a specialized salt-neutralizing wash and electrical hardening, humidity dropped to 48% and the system resumed efficient cycling, adding years to its lifespan.",
            "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/AlwaysOnAir/images/always_on_air_BackgroundImageNO_TRANPARENCY.png"
        },

        // --- CARDS LIST (Maintenance Tech) ---
        "SystemTypes": [
            {
                "title": "Bio-Active Treatment",
                "text": "Slow-release antimicrobial tablets that break down sludge and prevent 'jelly' clogs in your primary and secondary drain pans.",
                "image": ICONS.PURIFIER
            },
            {
                "title": "Salt-Shield Armor",
                "text": "Aerosol corrosion inhibitors applied to outdoor fins to create a microscopic barrier against Atlantic salt-air pitting.",
                "image": ICONS.CERTIFIED
            },
            {
                "title": "Ductless Deep Scrub",
                "text": "High-precision cleaning using bib kits for mini-splits to sanitize tight evaporator fins without mess.",
                "image": ICONS.INSTALL
            },
            {
                "title": "Static Pressure Sync",
                "text": "Blower motor calibration and amp-draw testing to ensure whisper-quiet operation and consistent airflow.",
                "image": ICONS.SMART_HOME
            }
        ],

        // --- MAINTENANCE PRO ADVICE ---
        "maintenanceTips": {
            "title": "The Pro’s Advice",
            "subtitle": "Expert tips to beat the Jacksonville humidity and heat.",
            "tips": [
                "The 20-Degree Rule: Your AC is designed to drop temps 20° from outside air. Setting it to 65° in a 98° July will only freeze your coils.",
                "Rinse the Crust: If you're within 10 miles of the ocean, gently hose your outdoor unit monthly (low pressure only) to remove salt.",
                "The 80% Rule: Keep 80% of your vents open. Closing rooms increases 'static pressure' and can burn out your blower motor.",
                "Vinegar is Not Enough: Vinegar won't break up a real 'slime' clog. Test your float switch monthly to ensure it actually kills the power."
            ],
            "footerContent": {
                "preLink": "Ensure you stay Always On. ",
                "linkUrl": "/maintenance",
                "linkText": "Join the Maintenance Club"
            }
        },

        // --- NEIGHBORHOODS ---
        "neighborhoods": {
            "headline": "Serving Jacksonville's Micro-Climates",
            "regions": [
                { "name": "Coastal Zones", "areas": "Jax Beach, Neptune Beach, Ponte Vedra, Queen’s Harbour (Salt-Air Protection)" },
                { "name": "Historic Districts", "areas": "Riverside, Avondale, San Marco (Airflow & Static Pressure Specialists)" },
                { "name": "Planned Communities", "areas": "Nocatee, St. Johns, eTown (High-Density Cooling Optimization)" }
            ]
        },

        // --- FAQ ---
        "faqList": [
            {
                "question": "How often should I service my AC in Jacksonville?",
                "answer": "Twice a year. Think of it like a car; if you drive 30,000 miles a year (which your AC does in Florida), you can't skip the maintenance."
            },
            {
                "question": "Why is my humidity still high when the AC is running?",
                "answer": "Your system might be 'short-cycling' or the blower speed is too high. An AC must run long enough to get the coil cold enough to pull water out."
            },
            {
                "question": "What is that 'loud thud' when my AC starts?",
                "answer": "This is 'hard starting.' It signals a struggling compressor or failing capacitor. We recommend a Hard-Start Kit to save your motor."
            },
            {
                "question": "Should I turn my AC off when I go to work?",
                "answer": "No! In the 904, humidity will skyrocket. Raise it 3-5 degrees instead so your AC doesn't have to 'wring out' the house for hours when you return."
            },
            {
                "question": "Is a tune-up required for my warranty?",
                "answer": "Yes. Most manufacturers (Trane, Carrier, etc.) require documented annual maintenance to keep your 10-year parts warranty valid."
            }
        ],

        // --- SCHEMA ---
        "schema": {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "AC Maintenance and Tune-Ups",
            "provider": {
                "@type": "HVACBusiness",
                "name": "Always On Air AC ",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "9633 Old St Augustine Rd",
                    "addressLocality": "Jacksonville",
                    "addressRegion": "FL",
                    "postalCode": "32257"
                }
            },
            "areaServed": ["Duval County", "Clay County", "Saint Johns County"]
        }
    }
];

export default serviceFormatter;

// --- 3. FETCHING FUNCTIONS ---

export const getServicesData = async () => {
    if (ALL_SERVICES_CACHE) {
        return ALL_SERVICES_CACHE;
    }
    try {
        // const apiData = undefined;
        const apiData = await SystemDataService.getServicesData();
        if (Array.isArray(apiData) && apiData.length > 0) {
            ALL_SERVICES_CACHE = apiData;
            return apiData;
        } else {
            console.warn('Services API returned empty, falling back to local formatter');
            ALL_SERVICES_CACHE = serviceFormatter;
            return serviceFormatter;
        }
    } catch (err) {
        console.error('Failed to load services data from API, using local fallback', err);
        return serviceFormatter;
    }
};

export const getAllServices = () => serviceFormatter;

export const getServiceBySlug = async (slug) => {
    if (SERVICE_SLUG_CACHE[slug]) {
        return SERVICE_SLUG_CACHE[slug];
    }
    if (ALL_SERVICES_CACHE) {
        const found = ALL_SERVICES_CACHE.find(service => service.slug === slug);
        if (found) {
            SERVICE_SLUG_CACHE[slug] = found;
            return found;
        }
    }
    try {
        const apiData = await SystemDataService.getServicesDataBySlug(slug);
        let result = null;
        if (Array.isArray(apiData)) {
            result = apiData.find(s => s.slug === slug) || apiData[0];
        } else if (apiData && typeof apiData === 'object') {
            result = apiData;
        }
        if (result) {
            SERVICE_SLUG_CACHE[slug] = result;
            return result;
        }
        console.warn(`Service API empty for slug: ${slug}, falling back to local.`);
        const localResult = serviceFormatter.find(service => service.slug === slug);
        if (localResult) SERVICE_SLUG_CACHE[slug] = localResult;
        return localResult;
    } catch (err) {
        console.error('Failed to load specific service from API, using local fallback', err);
        return serviceFormatter.find(service => service.slug === slug);
    }
};

export const isValidService = (slug) => {
    return serviceFormatter.some(service => service.slug === slug);
};